import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { TimeZoneApiModel, CreateCompanyParameters } from './cxone-first-phase-integration/cxone-first-phase-integration.model';

@Injectable({
  providedIn: 'root'
})
export class CXOneFirstPhaseIntegrationService {
    public dataObj: CXOneFirstPhaseIntegrationSharedData = {
        save: {
            CompanyName: "",
            SubdomainName: "",
            Partner: 1,
            TimeZoneSource: "UTC",
            TimeZoneDefault: "Not Set",
            ExtraTimeZone1: "Not Set",
            ExtraTimeZone2: "Not Set",
            ExtraTimeZone3: "Not Set",
            CredentialPrimary: "",
            CredentialSecret: "",
            Domain: "na1",
            CustomHierarchy: false,
            Message: "",
            Type: "pm",
            UseCaseSensitiveRawData: true,
        },
    };
    
    constructor(
        private cvApiService: CVApiService
    ) { }

    public async loadTimeZones() {
        try {
            let response = await this.cvApiService.get<TimeZoneApiModel>(`/api/v2/timezone/`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error(`Failed getting time zone information.`);
            throw err;
        }
    }

    public async loadSubDomainBase() {
        try {
            let response = await this.cvApiService.get<string>(`/api/v2/integration/sub_domain_base`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error(`Failed getting sub domain base.`);
            throw err;
        }
    }

    public async createCompany() {
        try {
            let response = await this.cvApiService.post(`/api/v2/integration/cxone/company`, this.dataObj.save);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error(`Failed creating new company '${this.dataObj.save.CompanyName}'.`);
            throw err;
        }
    }

    public async validateInc() {
        let parameters = {
            accessKeyId: this.dataObj.save.CredentialPrimary,
            accessKeySecret: this.dataObj.save.CredentialSecret,
            incontactRegionDomain: this.dataObj.save.Domain
        };
        try {
            let response = await this.cvApiService.post(`/api/v2/integration/validate_inc`, parameters);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error(`Failed getting Incontact validation.`);
            throw err;
        }
    }

    public async validateSubdomain() {
        try {
            let response = await this.cvApiService.get<boolean>(`/api/v2/integration/validate_cxone_subdomain/${this.dataObj.save.SubdomainName}`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error(`Failed getting subdomain validation.`);
            throw err;
        }
    }
}

export interface CXOneFirstPhaseIntegrationSharedData {
    save: CreateCompanyParameters;
}
